<template>
  <div class="flex appointment">
    <div class="basic">
      <appointment-profile :appointment="appointment" :edit_id="edit_id"></appointment-profile>
    </div>
    <!-- <div class="m&#45;AddBox"> -->
    <!--   <appointment&#45;family :appointment="appointment"></appointment&#45;family> -->
    <!-- </div> -->
    <div class="m-support">
      <appointment-history :appointment="appointment" :condition="condition" :edit_id="edit_id" type="true"></appointment-history>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appointment: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.appointment_id === this.appointment.id) {
      alert('AP情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.flex {
  display: flex;
}
.appointment {
  &:after {
    content: "\f1b9";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
button {
  border-radius: 0px;
}
.basic {
  max-width: 66%;
  flex-basis: 66%;
}
.m-AddBox {
  max-width: 33%;
  flex-basis: 33%;
}
.m-support {
  max-width: 34%;
  flex-basis: 34%;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
.m-box__inner2 {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// AppointmentIndex.vue?c32f45be